<template>
  <el-alert
    v-if="shopCtx.listTip"
    class="mb-3!"
    :title="shopCtx.listTip"
    :type="shopCtx.multiSelfAbnormal || shopCtx.emptySelfShops ? 'warning' : 'info'"
    show-icon
    :closable="false"
  />
  <!-- 搜索（仅实物订单；上门服务单见「上门服务 → 订单管理」） -->
  <ContentWrap>
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="68px"
    >
      <el-form-item
        v-if="shopCtx.selfScope ? shopCtx.multiSelfAbnormal : true"
        label="所属店铺"
        prop="shopId"
      >
        <el-select
          v-model="selectedShopId"
          class="!w-280px"
          clearable
          filterable
          :placeholder="shopCtx.selfScope ? '全部自营店汇总' : '全部'"
        >
          <el-option
            v-for="item in shopFilterOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态" prop="status">
        <el-select v-model="queryParams.status" class="!w-280px" clearable placeholder="全部">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.TRADE_ORDER_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="支付方式" prop="payChannelCode">
        <el-select
          v-model="queryParams.payChannelCode"
          class="!w-280px"
          clearable
          placeholder="全部"
        >
          <el-option
            v-for="dict in getStrDictOptions(DICT_TYPE.PAY_CHANNEL_CODE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
          class="!w-280px"
          end-placeholder="自定义时间"
          start-placeholder="自定义时间"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item label="订单来源" prop="terminal">
        <el-select v-model="queryParams.terminal" class="!w-280px" clearable placeholder="全部">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.TERMINAL)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="订单类型" prop="type">
        <el-select v-model="queryParams.type" class="!w-280px" clearable placeholder="全部">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.TRADE_ORDER_TYPE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="配送方式" prop="deliveryType">
        <el-select v-model="queryParams.deliveryType" class="!w-280px" clearable placeholder="全部">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.TRADE_DELIVERY_TYPE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="queryParams.deliveryType === DeliveryTypeEnum.EXPRESS.type"
        label="快递公司"
        prop="logisticsId"
      >
        <el-select v-model="queryParams.logisticsId" class="!w-280px" clearable placeholder="全部">
          <el-option
            v-for="item in deliveryExpressList"
            :key="item.id"
            :label="item.name"
            :value="item.id!"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="queryParams.deliveryType === DeliveryTypeEnum.PICK_UP.type"
        label="自提门店"
        prop="pickUpStoreId"
      >
        <el-select
          v-model="queryParams.pickUpStoreId"
          class="!w-280px"
          clearable
          multiple
          placeholder="全部"
        >
          <el-option
            v-for="item in pickUpStoreList"
            :key="item.id"
            :label="item.name"
            :value="item.id!"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="queryParams.deliveryType === DeliveryTypeEnum.PICK_UP.type"
        label="核销码"
        prop="pickUpVerifyCode"
      >
        <el-input
          v-model="queryParams.pickUpVerifyCode"
          class="!w-280px"
          clearable
          placeholder="请输入自提核销码"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="聚合搜索">
        <el-input
          v-show="true"
          v-model="queryParams[queryType.queryParam]"
          :type="queryType.queryParam === 'userId' ? 'number' : 'text'"
          class="!w-280px"
          clearable
          placeholder="请输入"
        >
          <template #prepend>
            <el-select
              v-model="queryType.queryParam"
              class="!w-110px"
              clearable
              placeholder="全部"
              @change="inputChangeSelect"
            >
              <el-option
                v-for="dict in dynamicSearchList"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['trade:order:query']"
          type="warning"
          plain
          :loading="exportDeliveryLoading"
          @click="handleExportDelivery"
        >
          <Icon class="mr-5px" icon="ep:download" />
          导出待发货
        </el-button>
        <el-button
          v-hasPermi="['trade:order:update']"
          type="warning"
          plain
          @click="openImportDelivery"
        >
          <Icon class="mr-5px" icon="ep:upload" />
          导入发货
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-table v-loading="loading" :data="list" row-key="id">
      <el-table-column label="店铺" width="100">
        <template #default="{ row }">{{ shopName(row.shopId) }}</template>
      </el-table-column>
      <OrderTableColumn :list="list" :pick-up-store-list="pickUpStoreList" :service-mode="false">
        <template #default="{ row }">
          <div class="flex items-center justify-center">
            <el-button
              v-hasPermi="['trade:order:query']"
              link
              type="primary"
              @click="openDetail(row.id)"
            >
              <Icon icon="ep:notification" />
              详情
            </el-button>
            <el-dropdown
              v-hasPermi="['trade:order:update']"
              @command="(command) => handleCommand(command, row)"
            >
              <el-button link type="primary">
                <Icon icon="ep:d-arrow-right" />
                更多
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item
                    v-if="
                      row.deliveryType === DeliveryTypeEnum.EXPRESS.type &&
                      row.status === TradeOrderStatusEnum.UNDELIVERED.status
                    "
                    command="delivery"
                  >
                    <Icon icon="ep:takeaway-box" />
                    发货
                  </el-dropdown-item>
                  <el-dropdown-item command="remark">
                    <Icon icon="ep:chat-line-square" />
                    备注
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </template>
      </OrderTableColumn>
    </el-table>
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <OrderDeliveryForm ref="deliveryFormRef" @success="getList" />
  <OrderUpdateRemarkForm ref="updateRemarkForm" @success="getList" />
  <OrderDeliveryImportForm
    ref="importDeliveryFormRef"
    :import-api="TradeOrderApi.importDelivery"
    @success="getList"
  />
</template>

<script lang="ts" setup>
import type { FormInstance } from 'element-plus'
import OrderDeliveryForm from '@/views/mall/trade/order/form/OrderDeliveryForm.vue'
import OrderUpdateRemarkForm from '@/views/mall/trade/order/form/OrderUpdateRemarkForm.vue'
import OrderDeliveryImportForm from '@/views/mall/trade/order/form/OrderDeliveryImportForm.vue'
import * as TradeOrderApi from '@/api/mall/trade/order'
import * as PickUpStoreApi from '@/api/mall/trade/delivery/pickUpStore'
import { DICT_TYPE, getIntDictOptions, getStrDictOptions } from '@/utils/dict'
import * as DeliveryExpressApi from '@/api/mall/trade/delivery/express'
import { DeliveryTypeEnum, TradeOrderStatusEnum } from '@/utils/constants'
import { OrderTableColumn } from './components'
import { useShopName } from '@/hooks/web/useShopName'
import { useMallStandaloneNav } from '@/hooks/web/useMallStandaloneNav'
import { useMallSelfShopContext } from '@/hooks/web/useMallSelfShopContext'
import { getShopSimpleList } from '@/api/merchant/shop-manager'
import download from '@/utils/download'

defineOptions({ name: 'TradeOrder' })
const { shopName } = useShopName()

const { currentRoute } = useRouter()
const { pushMall } = useMallStandaloneNav()
const {
  context: shopCtx,
  applyShopFilterToQuery,
  refresh: refreshShopCtx
} = useMallSelfShopContext()
const loading = ref(true)
const total = ref(0)
const list = ref<TradeOrderApi.OrderVO[]>([])
const queryFormRef = ref<FormInstance>()
/** 用户手动选中的店（自营多店时可收窄；平台视角可选任意店） */
const selectedShopId = ref<number | undefined>()
const shopFilterOptions = ref<{ id: number; name: string }[]>([])

const buildQueryParams = () => ({
  pageNo: 1,
  pageSize: 10,
  status: undefined as number | undefined,
  payChannelCode: undefined,
  createTime: undefined as string[] | undefined,
  terminal: undefined,
  type: undefined,
  deliveryType: undefined,
  logisticsId: undefined,
  pickUpStoreId: undefined,
  pickUpVerifyCode: undefined,
  /** 商城订单列表固定只查商城域（服务端 PHYSICAL=type∈0–5+非上门履约），服务单在「上门服务 → 订单管理」 */
  fulfillmentTypeGroup: 'PHYSICAL' as const,
  shopId: undefined as number | undefined,
  shopIds: undefined as number[] | undefined
})

const queryParams = ref(buildQueryParams())
const queryType = reactive({ queryParam: '' })

const dynamicSearchList = ref([
  { value: 'no', label: '订单号' },
  { value: 'userId', label: '用户UID' },
  { value: 'userNickname', label: '用户昵称' },
  { value: 'userMobile', label: '用户电话' }
])

const inputChangeSelect = (val: string) => {
  dynamicSearchList.value
    .filter((item) => item.value !== val)
    ?.forEach((item1) => {
      if (queryParams.value.hasOwnProperty(item1.value)) {
        delete queryParams.value[item1.value]
      }
    })
}

const refreshShopFilterOptions = async () => {
  await refreshShopCtx()
  if (shopCtx.value.selfScope) {
    shopFilterOptions.value = shopCtx.value.shops.map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
    if (shopCtx.value.singleShopId) {
      selectedShopId.value = shopCtx.value.singleShopId
    } else if (
      selectedShopId.value &&
      !shopFilterOptions.value.some((s) => s.id === selectedShopId.value)
    ) {
      selectedShopId.value = undefined
    }
  } else {
    const shops = (await getShopSimpleList()) as { id: number; name: string }[]
    shopFilterOptions.value = (shops || []).map((s) => ({
      id: s.id,
      name: s.name || `店铺${s.id}`
    }))
    selectedShopId.value = undefined
  }
}

const getList = async () => {
  loading.value = true
  try {
    queryParams.value.fulfillmentTypeGroup = 'PHYSICAL'
    if (shopCtx.value.selfScope) {
      applyShopFilterToQuery(queryParams.value as any, selectedShopId.value)
    } else {
      delete (queryParams.value as any).shopIds
      queryParams.value.shopId = selectedShopId.value
    }
    const data = await TradeOrderApi.getOrderPage(unref(queryParams))
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = async () => {
  queryParams.value.pageNo = 1
  await getList()
}

const resetQuery = async () => {
  queryFormRef.value?.resetFields()
  queryParams.value = buildQueryParams()
  await refreshShopFilterOptions()
  await handleQuery()
}

const openDetail = (id: number) => {
  pushMall(`/trade/order/detail/${id}`)
}

const message = useMessage()
const exportDeliveryLoading = ref(false)
const importDeliveryFormRef = ref<InstanceType<typeof OrderDeliveryImportForm>>()

const handleExportDelivery = async () => {
  try {
    await message.confirm(
      '将导出快递待发货订单清单（含「可用物流公司」Sheet），是否继续？'
    )
  } catch {
    return
  }
  exportDeliveryLoading.value = true
  try {
    // 导出用当前筛选，但服务端会强制待发货+快递
    const params = { ...unref(queryParams), pageNo: 1, pageSize: 10 }
    const data = await TradeOrderApi.exportDelivery(params)
    download.excel(data as Blob, '待发货发货清单.xlsx')
  } finally {
    exportDeliveryLoading.value = false
  }
}

const openImportDelivery = () => {
  importDeliveryFormRef.value?.open()
}

const deliveryFormRef = ref()
const updateRemarkForm = ref()
const handleCommand = async (command: string, row: TradeOrderApi.OrderVO) => {
  switch (command) {
    case 'remark':
      updateRemarkForm.value?.open(row)
      break
    case 'delivery':
      deliveryFormRef.value?.open(row)
      break
  }
}

watch(
  () => currentRoute.value,
  () => {
    getList()
  }
)

watch(
  () => shopCtx.value.selfScope,
  async () => {
    await refreshShopFilterOptions()
    await handleQuery()
  }
)

const pickUpStoreList = ref<PickUpStoreApi.DeliveryPickUpStoreVO[]>([])
const deliveryExpressList = ref<DeliveryExpressApi.DeliveryExpressVO[]>([])
onMounted(async () => {
  await refreshShopFilterOptions()
  await getList()
  pickUpStoreList.value = await PickUpStoreApi.getSimpleDeliveryPickUpStoreList()
  deliveryExpressList.value = await DeliveryExpressApi.getSimpleDeliveryExpressList()
})
</script>
